"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
exports.WindowButton = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  border: 1px solid #dee3f3;\n  flex: 0 13px;\n  margin-right: 7px;\n"], ["\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  border: 1px solid #dee3f3;\n  flex: 0 13px;\n  margin-right: 7px;\n"])));
var templateObject_1;
